import React, { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "@/components/Primitives";
import api from "@/lib/api";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/public/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <SectionHeading eyebrow="FAQ" title="Frequently asked questions" subtitle="Honest answers — no inflated promises." />
      <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
        {faqs.map((f) => (
          <AccordionItem key={f.id} value={f.id} className="glass rounded-2xl border-white/10 px-5">
            <AccordionTrigger className="text-white hover:no-underline py-5 text-left">{f.question}</AccordionTrigger>
            <AccordionContent className="text-slate-400 pb-5 leading-relaxed">{f.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
